/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SddcQuotaResponse { 
    vcf_org_id: string;
    added_ts: Date;
    end_ts: Date;
    start_ts: Date;
    computed_sddc_hours: number;
    effective_sddc_hours: number;
    quota_updated_ts: Date;
    usage_updated_ts: Date;
    used_sddc_hours: number;
    id?: number;
}

